<template>
    <div>
        <div 
            class="modal fade" 
            id="quotedResponseModal" 
            tabindex="-1" 
            aria-labelledby="quotedResponseModalLabel" 
            aria-hidden="true"
        >
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-dark" id="quotedResponseModalLabel">
                            Quoted Submited
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="d-flex justify-content-center align-items-center my-4 pb-4">
                            <h2>Quote submited with success!</h2>
                        </div>
                        <table class="table table-striped table-hover">
                            <tbody>
                                <tr v-for="(item, index) in partQuoted.parts" :key="index">
                                    <td>
                                        <div>
                                            <div>
                                                <h5>{{ item.part_quoted }}</h5>
                                            </div>
                                            <div>
                                                {{ currentDate }}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="d-flex align-items-center">
                                            <h5>{{ partQuoted.customer }}</h5>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="d-flex justify-content-end align-items-center">
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button 
                            type="button" 
                            class="btn btn-danger ms-2"
                            @click="downloadQuoteData"
                        >
                            <font-awesome-icon :icon="['fas', 'download']" />
                            <span class="ms-2">Download</span>
                        </button>
                        <button type="button" @click="close" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'QuotedResponseModal',
    props: {
        data: {
            type: Array,
            default: () => []
        },
        partQuoted: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        currentDate() {
            return new Date().toLocaleDateString();
        }
    },
    data() {
        return {
            resolvedData: [],
        }
    },
    methods: {
        hideQuote() {
            this.$emit('hideQuote');
        },
        downloadQuoteData() {
            this.$emit('downloadQuoteData');
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>